import { FaLink } from "react-icons/fa";

export function LinkComponent({ label, href }) {
    return !!href ? (
        <a href={href} target="_blank" rel="noopener noreferrer">
            <FaLink size={14} /> {!!label ? label : ""}
        </a>
    ) : "N/A";
}